<template>
    <div class="con">
        <!-- 商家首页页面 -->
        <div class="coninner">
            <div class="contop">
                <div class="userAvatar">
                    <img :src="$img(info.avatar)" v-if="info.avatar" alt="" />
                    <img :src="$Localimg('defaultAvatar.png')" v-else alt="" />
                </div>
                <div class="userName" v-text="info.nickname">
                </div>
            </div>
            <div class="cDetail flx jsb">
                <div class="cdLeft" style="width: 200px;">
                    <div class="clItem" :class="cur == 0?'active':''" @click="changeTab(0)">
                        <div class="shu" v-if="cur == 0"></div>
                        <div class="cItemInner">
                            <div class="cIcon">
                                <img :src="$Localimg('index1.png')" alt="" />
                            </div>
                            <div class="cName">
                                首页
                            </div>
                        </div>
                    </div>
                    
                    <div class="clItem" :class="cur == 1?'active':''"  @click="changeTab(1)">
                        <div class="shu" v-if="cur == 1"></div>
                        <div class="cItemInner">
                            <div class="cIcon">
                                <img :src="$Localimg('index2.png')" alt="" />
                            </div>
                            <div class="cName">
                                活动管理
                            </div>
                        </div>
                    </div>
                    
                    <div class="clItem" :class="cur == 2?'active':''"  @click="changeTab(2)">
                        <div class="shu" v-if="cur == 2"></div>
                        <div class="cItemInner">
                            <div class="cIcon">
                                <img :src="$Localimg('index3.png')" alt="" />
                            </div>
                            <div class="cName">
                                职位管理
                            </div>
                        </div>
                    </div>
                    
                    <div class="clItem" :class="cur == 3?'active':''" v-if="info.fwcg_status == 1"  @click="changeTab(3)">
                        <div class="shu" v-if="cur == 3"></div>
                        <div class="cItemInner">
                            <div class="cIcon">
                                <img :src="$Localimg('index4.png')" alt="" />
                            </div>
                            <div class="cName">
                                服务采购管理
                            </div>
                        </div>
                    </div>
                    
                   <div class="clItem":class="cur == 4?'active':''"  @click="changeTab(4)">
                        <div class="shu" v-if="cur == 4"></div>
                        <div class="cItemInner">
                            <div class="cIcon">
                                <img :src="$Localimg('index5.png')" alt="" />
                            </div>
                            <div class="cName">
                                企业信息
                            </div>
                        </div>
                    </div>
                    
                    <div class="clItem":class="cur == 5?'active':''"  @click="changeTab(5)">
                        <div class="shu" v-if="cur == 5"></div>
                        <div class="cItemInner">
                            <div class="cIcon">
                                <img :src="$Localimg('index6.png')" alt="" />
                            </div>
                            <div class="cName">
                                短信通知
                            </div>
                        </div>
                    </div>
                    
                    <div class="clItem":class="cur == 6?'active':''"  @click="changeTab(6)">
                        <div class="shu" v-if="cur == 6"></div>
                        <div class="cItemInner">
                            <div class="cIcon">
                                <img :src="$Localimg('index7.png')" alt="" />
                            </div>
                            <div class="cName">
                                账号设置
                            </div>
                        </div>
                    </div>
                </div>
                <div class="cdRight" style="width: 1240px;">
                    <shops @toConfirm="toConfirm" v-if="cur == 0"></shops>
                    <Activity v-if="cur == 1"></Activity>
                    <Zp v-if="cur == 2"></Zp>
                    <Service v-if="cur == 3"></Service>
                    <Company v-if="cur == 4"></Company>
                    <Mine v-if="cur == 6"></Mine>
                    <shortMessage @toConfirm="toConfirm" v-if="cur == 5"></shortMessage>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {shoUserInfo} from "@/api/index.js"
    import shops from './shop.vue'
    import Activity from '../activity/activity.vue'
    import Zp from '../zp/zp.vue'
    import Service from "../service/service.vue"
    import Company from "../company/company.vue"
    import Mine from "../shop/mine.vue"
    import shortMessage from './shortmessage.vue'
    export default {
        components: {
            shops,
            Activity,
            Zp,
            Service,
            Company,
            Mine,
            shortMessage
          },
        name: 'Shop',
        data() {
            return {
                cur:0,
                info:{}
            }
        },
        created() {
            this.getUser()
        },
        methods: {
            changeTab(e){
                let that = this 
                that.cur = e
            },
            toConfirm(){
                this.$router.push('/verify')
            },
            getUser(){
                let that = this 
                shoUserInfo().then((res) => {
                    console.log("user",res)
                    if(res.code == 1){
                        that.info = res.data
                    }
                })
            }
        }
    }
</script>

<style scoped>
    .clItem:hover{
         background: rgba(0,122,255,0.07) !important; 
         cursor: pointer;
    }
    .active{
        background: rgba(0,122,255,0.07) !important; 
    }
    .shu{
        height: 52px;
        width: 4px;
        background: #007AFF;
        position: absolute;
        left: 0;
        top:0;
        flex-shrink: 0;
    }
    .cIcon{
        width: 20px;
        height: 20px;
        margin-right: 6px;
    }
    .cName{
        font-size: 14px;
        color: #333333;
    }
    .cIcon img{
        width: 100%;
        height: 100%;
    }
    .cItemInner{
        display: flex;
        box-sizing: border-box;
        padding-left: 20px;
        align-items: center;
    }
    .clItem{
        display: flex;
        height: 52px;
        position: relative;
    }
    .cdRight{
        
        background: #fff;
        border-radius: 10px;
    }
    .cdLeft {
        
        background: #fff;
        padding: 32px 0;
        border-radius: 10px;
        flex-shrink: 0;
        margin-right: 14px;
        height: 428px;
    }

    .cDetail {
        width: 1200px;
        position: relative;
        top: -40px;
        margin: 0 auto;
    }

    .userAvatar {
        box-sizing: border-box;
        padding: 20px 0 12px;
        text-align: center;
    }

    .userAvatar img {
        width: 66px;
        height: 66px;
        border-radius: 50%;
    }
    
    .coninner {
        position: relative;
        background: #f8f8f8;
        /* height: 50vh; */
    }

    .contop {
        height: 180px;
        width: 100%;
        background: url('https://hrxsl.com/pcImages/indexBk.png') no-repeat;
        background-size: 100% auto;
    }

    .userName {
        font-size: 16px;
        color: #FFFFFF;
        text-align: center;
    }
</style>